export default __webpack_public_path__ + "static/media/helpingTeam_icon.7e73951b.webp";